const styles = theme => ({
  root: {
    padding: theme.spacing(0, 2),
  },
  skeleton: {
    width: '100px',
    height: '100px',
    transformOrigin: 'center',
  },
})

export default styles
